import { Box, ClickAwayListener, List, ListItem, ListItemIcon, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TargetAcheivedStars from "../../components/TargetAcheivedStars";
import { useTranslation } from "react-i18next";
import './styles.css';
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import { useDispatch, useSelector } from "react-redux";
import { draftData } from "../ReportEditor/staticReportData";
import { setExecutiveSummaryRichText, setReportData } from "../../redux/reducers/evaluation";
import { $generateHtmlFromNodes } from "@lexical/html";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import StackedHorizontalBar from "../../components/Charts/StackedHorizontalBar";
import { colors } from "../../common/pallette/colors";
import { saveExecutiveSummary } from "../../api/reports";
import { report } from "process";

const ReportsExecutiveSummary = () => {
    const [t] = useTranslation();
    const reportData = useSelector((state:any) => state.evaluation.reportData);
    const [editorContent, setEditorContent] = useState(reportData?.ClubOverview || '');
    const [editor] = useLexicalComposerContext();
    const currentClub = useSelector((state:any) => state.clubDetails);
    const dispatch = useDispatch();
    const seen = new Set();
    const criteriaGroups = reportData?.Criteria?.filter((d:any) => {
      if (seen.has(d.CriteriaGroupId)) return false;
      seen.add(d.CriteriaGroupId);
      return true;
    });
    const siteReviewPalette = [
      colors.grey.dark,
      colors.statusColors.met,
      colors.statusColors.partial,
      colors.statusColors.notMet
    ];
    const barChartDataGenerator = (barData:any) => {
        var notEval = 0;
        var met = 0;
        var partial = 0;
        var notMet = 0;
        const standards = barData || [];
        if(standards?.length > 0) {
            var key = 'Status';
            const criteriaArr = standards;
            criteriaArr.map((d:any) => {
            switch(d[key]){
                case 0:
                notEval++;
                break;
                case 1:
                notMet++;
                break;
                case 2:
                partial++;
                break;
                case 3:
                met++;
                break;
            }
            });
            const tempData:any = [
            {
                name: "NOT_EVALUATED",
                data: [notEval],
            },
            {
                name: "MET",
                data: [met],
            },
            {
                name: "PARTIAL",
                data: [partial]
            },
            {
                name: "NOT_MET",
                data: [notMet]
            }
            ];
            return(tempData);
        }
      };

    // const SyncPlugin = (props:any) => {
    //     const { content, setContent } = props;
    //     const [editor] = useLexicalComposerContext();
      
      //   // Sync Lexical content to React state
      //   useEffect(() => {
      //         // const savedEditorStateJSON:any = {
      //         //     "root": {
      //         //         "children": [
      //         //             {
      //         //                 "children": [
      //         //                     {
      //         //                         "detail": 0,
      //         //                         "format": 0,
      //         //                         "mode": "normal",
      //         //                         "style": "",
      //         //                         "text": "This is a sample data - new ",
      //         //                         "type": "text",
      //         //                         "version": 1
      //         //                     },
      //         //                     {
      //         //                         "detail": 0,
      //         //                         "format": 3,
      //         //                         "mode": "normal",
      //         //                         "style": "",
      //         //                         "text": "Style",
      //         //                         "type": "text",
      //         //                         "version": 1
      //         //                     }
      //         //                 ],
      //         //                 "direction": "ltr",
      //         //                 "format": "",
      //         //                 "indent": 0,
      //         //                 "type": "paragraph",
      //         //                 "version": 1,
      //         //                 "textFormat": 0,
      //         //                 "textStyle": ""
      //         //             }
      //         //         ],
      //         //         "direction": "ltr",
      //         //         "format": "",
      //         //         "indent": 0,
      //         //         "type": "root",
      //         //         "version": 1
      //         //     }
      //         // };
      //         // const initialEditorState = editor.parseEditorState(savedEditorStateJSON);
      //         // editor.setEditorState(initialEditorState);
      //     // return editor.registerUpdateListener(({ editorState }) => {
      //     //   editorState.read(() => {
      //     //     const text = $getRoot().getTextContent();
      //     //     setContent(text);
      //     //     const editorState = editor.getEditorState();
      //     //     //to store in db
      //     //     // console.log('editorState', editorState.toJSON());
      //     //     const htmlString:any = editorState.read(() => {
      //     //       return $generateHtmlFromNodes(editor, null);
      //     //     });
      //     //     dispatch(setExecutiveSummaryRichText(htmlString));
      //     //   });
      //     // });
      //     console.log('editorContent', content, editor);
      //     setContent(content);
      //   }, [editor]);
      
      //   // Sync React state back to Lexical when content changes
      //   useEffect(() => {
      //     editor.update(() => {
      //       const root = $getRoot();
      //       if (root.getChildren().length === 0 && content != null && content !== '') {
      //         // If empty, create a single paragraph node
      //         const paragraphNode = $createParagraphNode();
      //         paragraphNode.append($createTextNode(content));
      //         root.append(paragraphNode);
      //       }
      //     });
      //   }, [content, editor]);
      
      //   return null;
      // };

      useEffect(() => {
        const editorState = editor.getEditorState();
        const stringifiedEditorState = JSON.stringify(editorState.toJSON());
        if ((stringifiedEditorState == null ||
           stringifiedEditorState === '' ||
          stringifiedEditorState === '{"root":{"children":[],"direction":"ltr","format":"","indent":0,"type":"root","version":1}}') &&
          reportData?.ClubOverview !== null && reportData?.ClubOverview !== '') {
          const savedEditorStateJSON = JSON.parse(reportData?.ClubOverview);
          const initialEditorState = editor.parseEditorState(savedEditorStateJSON);
          editor.setEditorState(initialEditorState);
        }
      }, [editor]);

      const manageESUpdate = () => {
        const editorState = editor.getEditorState();
        const stringifiedEditorState = JSON.stringify(editorState.toJSON());
        console.log('editorState', editorState.toJSON(), stringifiedEditorState);
        if (stringifiedEditorState!== reportData?.ClubOverview) {
          dispatch(setReportData({...reportData, ClubOverview: stringifiedEditorState}));
          const tempDataToSave = {
            "clubOverview": stringifiedEditorState,
            "keyAchievements": reportData?.KeyAchievements,
            "keyAreasToImprove": null,
            "achievedStarRating": reportData?.AchievedStarRating,
            "isActionPlanIncluded": false,
            "isOverrideRating": false,
            "actionPlanTimeline": reportData?.ActionPlanTimeline,
            "clubId": currentClub?.clubId,
          };
          // saveExecutiveSummary(tempDataToSave);
        }
      };

    return (
        <Box className={'a4Spacing mb20'}>
            <Typography className="fw800 fs24 uppercase res mb20">{t('EXECUTIVE_SUMMARY')}</Typography>
            <Box className={'resHeader'}>
                <TargetAcheivedStars label={t('TARGET')} acheived={reportData?.ExecutiveSummary?.TargetStarRating} />
                <TargetAcheivedStars label={t('ACHIEVED')} acheived={reportData?.ExecutiveSummary?.AchievedStarRating} />
            </Box>
            <ClickAwayListener onClickAway={manageESUpdate}>
              <ContentEditable
                className={'ContentEditable__executiveSummary mb20'}
              />
            </ClickAwayListener>
            {/* <SyncPlugin content={editorContent} setContent={setEditorContent} /> */}
            <Typography className="fw800 fs18 uppercase res mb10">{t('CRITERIA_GROUPS')}</Typography>
            <List className="mb20">
              {
                criteriaGroups?.map((d:any) => {
                  return (
                    <ListItem>
                      {/* <ListItemIcon><FontAwesomeIcon color="#000" icon={faCircle} /></ListItemIcon> */}
                      <Box className="listItems">
                        <Typography className="mtbAuto">
                          {d.CriteriaGroupName}
                        </Typography>
                        <StackedHorizontalBar label="" data={barChartDataGenerator(reportData?.Criteria?.filter((j:any) => j.CriteriaGroupId === d?.CriteriaGroupId))} colorPalette={siteReviewPalette} width={100} />
                      </Box>
                    </ListItem> 
                  )
                })
              }
            </List>
        </Box>
    )
}

export default ReportsExecutiveSummary;




  // <Typography className="fw800 fs18 uppercase res mb10">{t('CRITERIA')}</Typography>
  // <List className="mb20">
  //   {
  //     reportData?.Criteria?.map((d:any) => {
  //       return (
  //         <ListItem>
  //           {/* <ListItemIcon><FontAwesomeIcon color="#000" icon={faCircle} /></ListItemIcon> */}
  //           <Box className="listItems">
  //             <Typography className="mtbAuto">
  //               {d.Name}
  //             </Typography>
  //             <StackedHorizontalBar label="" data={barChartDataGenerator(d?.Standards)} colorPalette={siteReviewPalette} width={100} />
  //           </Box>
  //         </ListItem> 
  //       )
  //     })
  //   }
  // </List>